import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros, all = false) {
  return httpAuth.get(`/crm/listanegra?${serialize({ ...filtros, all })}`, {
    tela: 'listanegra'
  })
}

export async function listFiltro (url, dados, all) {
  if (dados.tipo === 'pesquisa') {
    return httpAuth.get(`${url}?${dados.query}&${all}`)
  } else {
    return httpAuth.get(`${url}?${dados.query}&${all}`)
  }
}

export async function add (funcionalidade, dados) {
  return httpAuth.post('/crm/listanegra', dados, { funcionalidade: funcionalidade })
}

export async function edit (funcionalidade, id, dados) {
  return httpAuth.put(`/crm/listanegra/${id}`, dados, { funcionalidade: funcionalidade })
}

export async function del (funcionalidade, id) {
  return httpAuth.delete(`/crm/listanegra/${id}`, { funcionalidade: funcionalidade })
}
